exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#currentOutages tr,#outages tr{cursor:pointer}#currentOutages .row-link,#outages .row-link{color:inherit;text-decoration:none}.filter-panel{overflow:hidden;max-height:0;transition:max-height .35s ease}.filter-panel-open{max-height:1000px}.filter-panel-content{padding-left:15px;padding-bottom:.75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48baf1ce","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Outages.vue
// module id = 861
// module chunks = 0